var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" Sample is confirmed and the estimate delivery date is set to "+_vm._s(_vm.estimate)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }